import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import EditBooking from "../EditBooking/EditBooking";
import { Box } from "@mui/material";
import "./Table.scss";
import { TableHeader } from "./Head/Head";
import TableStyle from "./TableStyle";
import { TableContextWrapper } from "./TableContext";
import ChipsArray from "./Filter/FilterChip/FilterChip";
import SendBookingRequests from "../sendBookingRequests/SendBookingRequests";
import { useShallowSelector } from "../../hooks/useShallowSelector";
import Footer from "./Footer/Footer";
import RootState from "../../redux/types/rootState";
import {
  fetchBookings,
  setCurrentPage,
  setSelectedBooking,
} from "../../redux/slice/bookingSlice";
import CustomTableBody from "./Body/Body";
import { useAppDispatch } from "../../redux/dispatch/useAppDispatch";
import { IBooking } from "../../api/bookings/IBookings";

export default function MultiBookingTable() {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isEditButtonOpen, setEditButtonOpen] = useState(false);
  const [isActionFormOpen, setActionFormOpen] = useState(false);
  const [editBookingData, setEditBookingData] = useState<IBooking>(
    {} as IBooking
  );
  const bookingsResponse = useShallowSelector(
    (state: RootState) => state.bookings.bookingsResponse
  );

  const selectedBookingsFromApi = useShallowSelector(
    (state: RootState) => state.bookings.selectedBookingsFromApi
  );

  const isSelectableBookingLoading = useShallowSelector(
    (state: RootState) => state.bookings.isSelectableBookingLoading
  );

  useEffect(() => {
    if (!isSelectableBookingLoading) toggleAllCheckboxes({ forceCheck: false });
  }, [isSelectableBookingLoading]);

  const { results: apiBookings } = bookingsResponse || {};

  const dispatch = useAppDispatch();

  const handleEditClick = (editBookingDataFromClickedRow: IBooking) => {
    setEditButtonOpen(true);
    setEditBookingData(editBookingDataFromClickedRow);
  };

  // Function to toggle the state of all checkboxes
  const toggleAllCheckboxes = ({
    forceCheck,
  }: { forceCheck?: boolean } = {}): void => {
    const check = forceCheck !== undefined ? forceCheck : !isChecked;
    setIsChecked(check);
    if (check) {
      if (apiBookings) {
        dispatch(setSelectedBooking(selectedBookingsFromApi));
      }
    } else {
      dispatch(setSelectedBooking([]));
    }
    // Use JavaScript to select and update all individual checkboxes
    const checkboxes = document.querySelectorAll<HTMLInputElement>(
      'input[type="checkbox"]'
    );
    checkboxes.forEach((checkbox) => {
      checkbox.checked = check;
    });
  };
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (!isEditButtonOpen)
        if (event.key === "Enter") {
          dispatch(fetchBookings({ page: 1 }));
        }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [isEditButtonOpen]);

  const closeEditModal = () => {
    setEditButtonOpen(false);
    setEditBookingData({} as IBooking);
  };

  const handleSendButtonClick = () => {
    setActionFormOpen(true);
  };

  const closeSendButtonClick = () => {
    setActionFormOpen(false);
  };
  const classes = TableStyle();
  return (
    <Box id="content-container-id">
      <TableContextWrapper>
        <Grid container item md={12}>
          <ChipsArray />
        </Grid>
        <Box className={classes.contentContainer}>
          <EditBooking
            booking={editBookingData}
            isOpen={isEditButtonOpen}
            onClose={closeEditModal}
          />
          <SendBookingRequests
            isOpen={isActionFormOpen}
            onClose={closeSendButtonClick}
          />
          <Grid item xs={12} container className={classes.grid}>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table style={{ minWidth: "1800px" }}>
                <TableHeader
                  isChecked={isChecked}
                  toggleAllCheckboxes={() => toggleAllCheckboxes()}
                />
                <CustomTableBody handleEditClick={handleEditClick} />
              </Table>
            </TableContainer>
            <Footer
              classes={classes}
              handleSendButtonClick={handleSendButtonClick}
              onPageChange={async (event, pageNumber) => {
                await dispatch(
                  fetchBookings({
                    page: pageNumber,
                    triggerGetSelectedBookings: false,
                  })
                ).unwrap();
                dispatch(setCurrentPage(pageNumber));
              }}
            />
          </Grid>
        </Box>
      </TableContextWrapper>
    </Box>
  );
}
